<template>
  <div>
    <Head title="Applicant Contact" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" href="/applicants">{{$t('applicants.applicants')}}</Link>
      <span class="text-gray-400 font-medium">/ </span> {{$t('applicants.new')}}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="">
        <Form :form-data="form" :genders="genders" :nationalities="nationalities" :civil_states="civil_states" :languages="languages" :locations="locations"></Form>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <DuplicateUsers @confirmed="confirmDuplicate" @cancel="cancelDuplicate" :first-name="form.first_name" :last-name="form.last_name" @click="form.processing = true">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{$t('global.create')}}</loading-button>
          </DuplicateUsers>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import Form from './Form'
import axios from "axios";
import DuplicateUsers from "@/Components/DuplicateUsers";

export default {
  components: {
    DuplicateUsers,
    Form,
    Head,
    Link,
    LoadingButton,
  },
  props: {
    genders: Array,
    nationalities: Array,
    civil_states: Array,
    languages: Array,
    locations: Object
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        date_birth: '',
        national_registry: '',
        phone: [],
        street: '',
        street_number: '',
        zip_code: '',
        city: '',
        gender_id: 0,
        nationality_id: null,
        civil_state_id: null,

        language_ids: [],
        language_field: '',
        note: '',
        date_imprisonment: null,
        reason_imprisonment: null,
        location_id: null,
        birth_place: null,
        email: null,
        residence_permit: null,
        income: null,
        mutuality: null,
        syndicate: null,
        closed: false,
      }),
    }
  },
  computed: {
    name(){
      return this.form.first_name + ' ' + this.form.last_name
    }
  },
  methods: {
    store() {
      this.form.post('/applicants')
    },
    confirmDuplicate() {
      this.store()
    },
    cancelDuplicate() {
      this.form.processing = false
    }
  },
}
</script>
